import gql from 'graphql-tag'

export const CREATE_CINEHILL_2026_PACKAGE_PROMO_CODES = gql`
  mutation CreateCinehill2026PackagePromoCodes($eventId: Int!) {
    createCinehill2026PackagePromoCodes(eventId: $eventId)
  }
`

export const GET_PROMO_CODE = gql`
  query GetPromoCode(
    $organizationSlug: String!
    $promoCodeId: Int!
    $pagination: Pagination!
    $searchTerm: String
  ) {
    getPromoCode(
      organizationSlug: $organizationSlug
      promoCodeId: $promoCodeId
      pagination: $pagination
      searchTerm: $searchTerm
    ) {
      promoCode {
        id
        name
        code
        ticketsPerOrder
        from
        to
        pauseFrom
        pauseTo
        discountType
        discountPercentage
        discountAmount
        currency
        createdAt
        updatedAt
        orderItems {
          id
          event {
            id
            title
            from
          }
          name
          type
          price
          currency
          createdAt
          updatedAt
          quantity
          from
          to
          OrderItemPromoCode {
            id
            quantity
            initialQuantity
            unlimited
            soldQuantity
          }
        }
      }
      count
    }
  }
`
export const GET_PROMO_CODE_BY_NAME = gql`
  query GetPromoCodeByName($promoCode: String!, $eventId: Int!) {
    getPromoCodeByName(promoCode: $promoCode, eventId: $eventId) {
      id
      discountType
      name
      code
      discountPercentage
      discountAmount
      createdAt
      updatedAt
      from
      to
      pauseFrom
      pauseTo
      ticketsPerOrder
      remainingTickets
      events {
        id
        title
      }
      orderItems {
        id
        name
        eventId
        OrderItemPromoCode {
          id
          quantity
          unlimited
        }
      }
    }
    getAndValidateMembershipUserByCode(code: $promoCode, eventId: $eventId) {
      id
      name
      code
      userId
      membershipPlan {
        name
        id
        amount
        orderItemTemplates {
          id
        }
      }
    }
    findAndValidatePrepaidCouponUserByCodeAndEvent(code: $promoCode, eventId: $eventId) {
      id
      name
      code
      redeemedCouponItems
      prepaidCoupon {
        id
        name
        from
        to
        couponItems {
          id
          ticketAmount
          eventTemplateId
          type
          performanceTypes
          eventTemplate {
            id
            title
          }
          couponItemInterest {
            id
            interest {
              id
              type
              name
            }
          }
        }
      }
    }
    validateOrderItemAccessCode(eventId: $eventId, accessCode: $promoCode)
  }
`

export const GET_PROMO_CODES = gql`
  query GetPromoCodes($organizationSlug: String!, $pagination: Pagination!, $searchTerm: String) {
    getPromoCodes(
      organizationSlug: $organizationSlug
      pagination: $pagination
      searchTerm: $searchTerm
    ) {
      promoCodes {
        id
        name
        code
        ticketsPerOrder
        from
        to
        pauseFrom
        pauseTo
        discountType
        discountPercentage
        discountAmount
        currency
        createdAt
        updatedAt
      }
      count
    }
  }
`

export const CREATE_PROMO_CODE = gql`
  mutation CreatePromoCode($organizationSlug: String!, $input: PromoCodeInput!) {
    createPromoCode(organizationSlug: $organizationSlug, input: $input)
  }
`

export const UPDATE_PROMO_CODE = gql`
  mutation UpdatePromoCode(
    $organizationSlug: String!
    $promoCodeId: ID!
    $input: UpdatePromoCodeInput!
  ) {
    updatePromoCode(
      organizationSlug: $organizationSlug
      promoCodeId: $promoCodeId
      input: $input
    ) {
      id
      name
      code
      ticketsPerOrder
      from
      to
      pauseFrom
      pauseTo
      discountType
      discountPercentage
      discountAmount
      currency
    }
  }
`

export const DELETE_PROMO_CODE = gql`
  mutation DeletePromoCode($organizationSlug: String!, $promoCodeId: Int!) {
    deletePromoCode(organizationSlug: $organizationSlug, promoCodeId: $promoCodeId)
  }
`

export const DELETE_PROMO_CODES = gql`
  mutation DeletePromoCodes($organizationSlug: String!, $promoCodeIds: [Int!]!) {
    deletePromoCodes(organizationSlug: $organizationSlug, promoCodeIds: $promoCodeIds)
  }
`

export const REMOVE_TICKETS_FROM_PROMO_CODE = gql`
  mutation RemoveTicketsFromPromoCode(
    $organizationSlug: String!
    $promoCodeId: Int!
    $orderItemIds: [Int!]!
  ) {
    removeTicketsFromPromoCode(
      organizationSlug: $organizationSlug
      promoCodeId: $promoCodeId
      orderItemIds: $orderItemIds
    )
  }
`

export const ADD_TICKETS_TO_PROMO_CODE = gql`
  mutation addTicketsToPromoCode(
    $organizationSlug: String!
    $promoCodeId: Int!
    $orderItemIds: [Int!]!
  ) {
    addTicketsToPromoCode(
      organizationSlug: $organizationSlug
      promoCodeId: $promoCodeId
      orderItemIds: $orderItemIds
    )
  }
`
